<template>
  <section>
    <aside>
        <v-tabs
          color="black"
          slider-color="black"
          fixed-tabs 
          v-model="tab"
        >
          <v-tab href="#datasheets-overview">
              Datasheets overview
          </v-tab>
          <v-tab href="#summary-table">
              Summary table
          </v-tab>
        </v-tabs>
    </aside>
    <v-container fluid>
      <v-row>
        <v-col cols="12" :lg="3" :xl="2">
          <aside>
            <catalogue-selector></catalogue-selector>
          </aside>
        </v-col>
        <v-col cols="12" :lg="9" :xl="10">
          <article v-if="!loadingHeader && !loadingTable">
            <v-tabs-items v-model="tab">
              <v-tab-item value="datasheets-overview">
                <datasheets-overview
                  v-bind:classification="this.classification"
                  v-bind:category="this.category"
                  v-bind:datasheets="this.datasheets">
                </datasheets-overview>
              </v-tab-item>
              <v-tab-item value="summary-table">
                <summary-tables
                  v-bind:classification="this.classification"
                  v-bind:category="this.category"
                  v-bind:datasheets="this.datasheets">
                </summary-tables>
              </v-tab-item>
            </v-tabs-items>
          </article>
          <article v-else>Loading ...</article>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import DatasheetsOverview from './DatasheetsOverview.vue';
import SummaryTables from './SummaryTables.vue';
import CatalogueSelector from './CatalogueSelector.vue'

export default {
  name: "DatasheetCatalogue",
  components: {DatasheetsOverview, SummaryTables, CatalogueSelector},
  
  created () {
  this.fetchData();
  },
  watch: {
    // call again the method if the route changes
    '$route': 'fetchData'
  },
    
  data () {
      return {
          tab: null,
          classification: null,
          category: null,
          datasheets: null,
          researchMode: null,
          loadingHeader: false,
          loadingTable: false
      }
  },
  methods: {
    fetchData () {
      this.researchMode = this.$route.path.split("/")[2];
      // fetch category or classification
      if(this.researchMode==="categories") {
        this.fetchDataCategory();
      }else{
        this.fetchDataClassification();
      }
      // fetch datasheets
      this.fetchDataDatasheets();
    },
    fetchDataClassification () {
      this.error = null
      this.loadingHeader = true

      // replace `getPost` with your data fetching util / API wrapper
      this.axios
      .get('classifications/'+this.$route.params.code)
      .then(response => {
        this.classification = response.data;
        this.category = null
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      })
      .finally(() => this.loadingHeader = false)
    },
    fetchDataCategory () {
      this.error = null
      this.loadingHeader = true

      // replace `getPost` with your data fetching util / API wrapper
      this.axios
      .get('categories/'+this.$route.params.code)
      .then(response => {
        this.category = response.data,
        this.classification = this.category.classification
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      })
      .finally(() => this.loadingHeader = false)
    },
    fetchDataDatasheets () {
      this.error = null
      this.loadingTable = true
      // replace `getPost` with your data fetching util / API wrapper
      this.axios
      .get(this.researchMode+'/'+this.$route.params.code+'/datasheets')
      .then(response => {
        this.datasheets = response.data
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      })
      .finally(() => this.loadingTable = false)
    }
  }
}
</script>

<style scoped>
</style>